(function(){
	angular
		.module('historicoListModule', []);
})();